<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="$t('initialization.iinsurance.isInfo')"            
            v-bind:titleRef="'titleElementInsurance'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            {{$t('initialization.iinsurance.checkinsu')}}
        </p>

          <b-row>           
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="$t('Shared.Selected')"
                        v-bind:Options="StatusList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Status"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownStatus"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="$t('Shared.Category')"
                        v-bind:Options="CategoryList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Category"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCategory"/>
            </b-col>            
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="$t('Shared.TransactionType')"
                        v-bind:Options="TransactionList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Transaction"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownTransaction"/>
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <div class="text-center text-md-right mt-3">
                    <button 												
                        type="button"
                        v-on:click="getInsuranceList"
                        class="btn btn-primary btn-login mx-2 pull-right"												
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}            
                    </button>
                </div>
            </b-col>
               
        </b-row>

         <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

          <div class="flex-container">
              <div class="row">                
              
              <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll" 
                  v-on:change="onChangeSelectAll"                
               /> 
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('Shared.selected') }}</span>
              </div>  
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group" dir="ltr">
                          <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="modelSearch"                          
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"                               
                                v-on:click="FindinItems"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
                  
          
                                     
              </div>
          </div>

         
        <MdTablePaginationClient 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage" 
            v-bind:SelectAll="UseSelectTableAll"             
            v-bind:pageOptions="pageOptions"
            :iconSelected="IconSelected"
            :editIconEvent="EditPrior"
            :onFiltered="onFiltered"               
            v-bind:VisibleEditIcon="true"                        
            :onRowSelected="onRowSelected"    
            :pageChanged="pageChanged"
            :RowClick="RowClicked"        
            :perPageFunction="PerPageFunction">                
        </MdTablePaginationClient>


        <IniModalEditPriorAutho 
            v-if="showModalEditPriorAutho"
            v-bind:InsuranceCode="InsuCode"
            v-bind:GoalEdit="{}"
            @OnResetModal="Reset($event)"
            v-bind:ModalId="'iModalIdEditPriorAutho'" 
            v-bind:TitleWindow="'Edit Insurance '+InsuranceName"            
        />

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"           
            v-bind:Name="'btnInsuranceBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnInsuranceNext'"
            v-bind:ClassProp="'mx-2'"/>  

        <MdButton
            v-bind:isReadOnly="!PendingChanges"
            v-bind:Label="$t('Shared.Save')"
            v-on:click="UpdateSelectedInsu()"
            v-bind:Name="'btnInsurance'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script>
import { EventBus } from '@/event-bus.js';
import ISetup from '@/services/isetup.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils.js'

export default {
  beforeRouteLeave(to, from, next) {
	if(this.PendingChanges) {
		this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('initialization.iinsurance.sIns'),
          okTitle: this.$t('Shared.BtnSave'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(async value => {
            if(!value){
              next();
            } else {
              await this.ClickOffRoute();
             var f = this.WasSaved;             
              if(f){
                  next();
              }
            
            }
          })		
	} else {
		next()
	}
    },


  name: 'IniInsurance',
   mixins: [ShowMessage, DBFunctions], 
  data(){
    return{
        OffRoute:false,
        WasSaved:false,
        TransactionList:[            
            {code:"A",description:this.$t('initialization.iinsurance.insClPartA')},
            {code:"B",description:this.$t('initialization.iinsurance.insClPartB')},
            {code:"",description:this.$t('Shared.All')}
        ],
        Transaction:{code:"",description: this.$t('Shared.All')},
        showModalEditPriorAutho:false,        
        parameter:{
            SearchCriteria:"",
            PageNumber : 0,
            PageSize:0,
        },
        InsuranceName:"",
        ShowMessageIsEmpty:false,
        PendingChanges:false,
        items:[],
        itemscopy:[],
        Status:{code:null,description:this.$t('Shared.All')},
        StatusList:[
            {code:true,description:this.$t('Shared.TitleYes')},
            {code:false,description:this.$t('Shared.TitleNo')},
            {code:null,description:this.$t('Shared.All')}
        ],
        Category:{code:"",description:this.$t('Shared.All')},
        CategoryList:[
            {code:"MA",description:this.$t('initialization.iinsurance.mPartA')},
            {code:"MB",description:this.$t('initialization.iinsurance.mPartB')},
            {code:"MC",description:this.$t('initialization.iinsurance.Medicaid')},
            {code:"CI",description:this.$t('initialization.iinsurance.comIns')},
            {code:"BL",description:this.$t('initialization.iinsurance.bCrossB')},
            {code:"",description:this.$t('Shared.All')}
        ],
        InsuCode:"",
        fields:[
            { key: 'payerName', sortable: true, label: this.$t('Shared.colInsuranceName'), class: 'text-rigth' },         
            { key: 'indicatorDescription', sortable: true, label: this.$t('Shared.Category'), class: 'text-rigth' },
            { key: 'transactionType', sortable: true, label: this.$t('Shared.TransactionType'), class: 'text-rigth' },
            { key: 'insuranceCode', sortable: true, label: '', class: 'text-rigth hidden' },  
            { key: 'payerId', sortable: true, label: this.$t('initialization.iinsurance.pId'), class: 'text-rigth' },
            { key: 'enrollmentRequiredTranslated', sortable: true, label: this.$t('initialization.iinsurance.enRequired'), class: 'text-rigth' },
            { key: 'userPriorAuthorizationTranslated', sortable: true, label: this.$t('insuranceSetup.uAuthorization'), class: 'text-rigth' },
            //{ key: 'priorAuthorizationBasedOn', sortable: true, label: this.$t('insuranceSetup.pAuthorizationBasedOnpAuthorizationBasedOn'), class: 'text-rigth' },
            //{ key: 'useDateRangeForPriorAuthorizationTranslated', sortable: true, label: 'Use Date Range For PriorAuthorization', class: 'text-rigth' },
            //{ key: 'UseUnitsAs', sortable: true, label: 'Use Units As', class: 'text-rigth' },
            //{ key: 'warnMeDayBeforeEndDate', sortable: true, label: 'Warn Me Day Before EndDate', class: 'text-rigth' },   
            //{ key: 'warnMeUnitsBeforeEndDate', sortable: true, label: 'Warn Me Units Before EndDate', class: 'text-rigth' },                      
        ],
        indexSelected : 0,
        SelectedRecords:0,
        UseSelectTableAll:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        modelSearch:"",
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',

    }
  },
  methods:{

    ChangeDropDownTransaction(item){
        this.Transaction = item;
        this.getInsuranceList();

    },

    onFiltered(){

    },

    Reset(){
        this.showModalEditPriorAutho = false;
        this.getInsuranceList();
    },

    IconSelected(){

    },

    RowClicked(item,index,event){
        this.indexSelected = index;     
    if(event.target.getAttribute('btn') === null){
        if(item.selected){      
          this.$set(item, 'selected', false);         
        }else{
          this.$set(item, 'selected', true);       
        }        
        EventBus.$emit('rowClicked', item); 
        this.PendingChanges = !Utils.HaveChangesSelected(this.items,this.itemscopy) ? true : false; 
    }           
    },

    FindinItems(){       

         this.items = this.itemscopy;
         let arr = this.items;
         let temp = [];

         if(this.modelSearch){
            arr.forEach(element => {
              if(element.payerName && element.payerName.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.transactionType && element.transactionType.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.payerId && element.payerId.toUpperCase().includes(this.modelSearch.toUpperCase()) ||

                element.indicatorDescription && element.indicatorDescription.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.enrollmentRequiredTranslated && element.enrollmentRequiredTranslated.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.userPriorAuthorizationTranslated && element.userPriorAuthorizationTranslated.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.priorAuthorizationBasedOn && element.priorAuthorizationBasedOn.toUpperCase().includes(this.modelSearch.toUpperCase()) ||

                element.useDateRangeForPriorAuthorizationTranslated && element.useDateRangeForPriorAuthorizationTranslated.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.UseUnitsAs && element.UseUnitsAs.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.warnMeDayBeforeEndDate && element.warnMeDayBeforeEndDate.toString().toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.warnMeUnitsBeforeEndDate && element.warnMeUnitsBeforeEndDate.toString().toUpperCase().includes(this.modelSearch.toUpperCase())              
              ){
                 temp.push(element);
               }
            })
         }else{
            temp = this.itemscopy;
         }
        this.items = temp;
        this.totalRows = this.items.length;
    },

    ChangeDropDownStatus(item){
        this.Status = item;
        this.getInsuranceList();
    },

    ChangeDropDownCategory(item){
        this.Category = item;
        this.getInsuranceList();
    },

    EditPrior(item){
        this.InsuCode = item.insuranceCode;
        this.InsuranceName = item.payerName;
        this.showModalEditPriorAutho = true;
    },

    async getInsuranceList(){   
      let param = {
        TransactionType:this.Transaction.code,
        Selected:this.Status.code,
        Category:this.Category.code
      } 
      await ISetup.getAllIsurances(param)
      .then((response) => {      
           if (response.status == "200") {              
                this.items = response.data;  
                let count = 0;
                this.items.forEach(element => {
                    if(element.transactionType === "1"){
                        element.transactionType = "";
                    }
                    if(element.selected){
                        count++;
                    }
                });

                this.SelectedRecords = count;

                this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;
                this.totalRows = this.items.length; 
               // this.itemscopy = [...this.items]; 
                this.itemscopy = JSON.parse(JSON.stringify(this.items));          
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },



     CompareChanged(insuranceCode,selected){    
      const record = this.itemscopy.find(item => item.insuranceCode === insuranceCode);
      let changed = record.selected !== selected;

      if(changed){
        record.selected = selected;
      }
      return changed;
    },

     getSelection(){
        let arr = [];
        this.items.forEach(element => {          
          if(this.CompareChanged(element.insuranceCode,element.selected)){
            arr.push({InsuranceCode:element.insuranceCode,selected:element.selected});
           }
        });
        return arr;
    },

    async ClickOffRoute(){
         this.OffRoute = true;
         await this.UpdateSelectedInsu();
      },

    async UpdateSelectedInsu(){ 
      this.WasSaved = true;   
      await ISetup.UpdateSelectedInsurance(this.getSelection())
      .then((response) => {      
           if (response.status == "200") { 
            this.PendingChanges = false;
           }           
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },    

     onChangeSelectAll(v){
        if(v){
        this.SelectedRecords = this.items.length; 
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true); 
        }
      }else{
        this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
           this.$set(this.items[j], 'selected', false); 
        }
      }
    },

    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
      //  this.SearchAppTypes();   
    },

    pageChanged(page){
        this.currentPage = page;    
       // this.SearchAppTypes();   
    },

    SelectAllRecords(){
      this.SelectedPage = this.items.length;
      this.wasSelectedAll = true;
    },

     onRowSelected(){ 
     this.SelectedRecords = 0;
     if(this.items.length > 0){
    for(var i = 0; i < this.items.length; i++){
      if(this.items[i].selected){
        this.SelectedRecords++;
      }
    }
     }     
    },
    
    Next(){
       // this.$router.push({ name:'iprograms'});
    },

    Back(){
     //   this.$router.push({ name:'iusers'}); 
    }
  },
  created(){
    this.getInsuranceList();
     EventBus.$on("rowClicked", function () {        
        this.SelectedRecords = 0;
            for(var i = 0; i < this.items.length; i++){
                if(this.items[i].selected){
                    this.SelectedRecords++;
                }
            }   
     }.bind(this));
  },
  mounted(){

  }   
};
</script>


